import { Component, OnInit, OnChanges, Input, Output,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { UserPreference, WidgetDetailParam, DateRangeParam, Level2WidgetDetailParam } from '../../../models';
import { AnalyticsService, CommonService, WidgethelperService } from '../../../services';
import { ExcelGeneratorService } from '../../../services/excel-generator.service';
import { appSettings, errorMessages } from '../../../settings';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-widgetdetails',
  templateUrl: './widgetdetails.component.html',
  styleUrls: ['./widgetdetails.component.scss']
})
export class WidgetdetailsComponent implements OnInit,OnChanges {
  loading: boolean = false;
  dynamicList: any[];
  ColumnsMatrix: any[] = [];
  Level2ColumnsMatrix: any[] = [];
  WidgetTitle: string = "";

  pageSize: number = 20;
  pageNumber: number = 1;
  TotalRecordCount: number = 0;
  errorMessage: string;
  widgetParam: WidgetDetailParam = new WidgetDetailParam();
  Level2widgetParam: Level2WidgetDetailParam = new Level2WidgetDetailParam();
  showExporttoExcel: boolean = true;
  @Input() Widgetdata: any;
  @Output() closeModal = new EventEmitter();
  @Input() showCancelledOrders: any = true;
  @Input() widgetDetailInfo: any;
  @ViewChild('detailTable') detailTable: any;

  constructor(
    private _router: Router,
    private _analyticsService: AnalyticsService,
    private _excelGeneratorService: ExcelGeneratorService,
    private _widgetHelper: WidgethelperService,
    private _commonService: CommonService) { }

  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: 'fa fa-sort-desc',
    pagerLeftArrow: 'fa fa-chevron-left',
    pagerRightArrow: 'fa fa-chevron-right',
    pagerPrevious: 'fa fa-step-backward',
    pagerNext: 'fa fa-step-forward'
  }

  ngOnInit() {
    if(this.Widgetdata){
      switch (this.Widgetdata.type) {
        case 'OpenOrders':
          this.showExporttoExcel = false;
          break;
      }
    }  
  }
  ngOnChanges(){
    console.log(" ngOnChanges ",this.widgetDetailInfo);
    if(!this.showCancelledOrders)
        this.SetFilters();
  }
  navigatePage() {
   // this._router.navigateByUrl('/home');
   var appBody = document.getElementById("appBody");
   appBody.className = "";
   this.closeModal.emit();
  }

  exportWidgetData() {
    if (this.TotalRecordCount > 0) { this.getWidgetDetail(this.TotalRecordCount, 1, true); }
  }

  exportLevel2WidgetData(data){
    this._excelGeneratorService.exportData(data, this.Level2ColumnsMatrix, 
        (this.Widgetdata.Title ? (this.Widgetdata.Title + '_Detail' ) : "WidgetDataDetail"));
  }

  setPage(pageNum) {
    this.pageNumber = pageNum;
    this.getWidgetDetail(this.pageSize, this.pageNumber);
  }

  SetFilters(){  
    let userPref: UserPreference = this._commonService.getUserPreference();
    this.widgetParam.CustomerId = userPref.CustomerId;
    this.widgetParam.FacilityId = userPref.FacilityId;
    this.widgetParam.WidgetType = this.Widgetdata.type;

    let setting = this.Widgetdata.widgetsettings;
    let criteria = setting && setting.Criteria ? JSON.parse(setting.Criteria) : null; 
    let timezoneOffset = (new Date()).getTimezoneOffset();  
    let dateParam: DateRangeParam = new DateRangeParam();        

    switch (this.Widgetdata.type) {
      case appSettings.OpenPicksTask: 
            if(criteria){
              this.widgetParam.TaskRefNumber = criteria.TaskRefNumber;      
            }
            this.getWidgetDetail(this.pageSize, this.pageNumber); 
            break;
      case appSettings.AgedOrders: 
            if(criteria){
              this.widgetParam.ReportDate = criteria.ReportDate;      
            }
            this.getWidgetDetail(this.pageSize, this.pageNumber);
            break;
      case appSettings.HospitalSummary: 
            if(criteria){
              this.widgetParam.ReportDate = criteria.ReportDate; 
              this.widgetParam.StartHours = criteria.StartHours;
              this.widgetParam.EndHours = criteria.EndHours;     
            }
            this.getWidgetDetail(this.pageSize, this.pageNumber);
            break;      
      case appSettings.AgedTasks:       
      case appSettings.AgedOrdersPutwall:    
      case appSettings.TimeInCubby:  
            if(criteria){
              this.widgetParam.StartDate = criteria.StartDate;
              this.widgetParam.EndDate = criteria.EndDate;              
            }
            this.getWidgetDetail(this.pageSize, this.pageNumber); 
            break;
      case appSettings.ZoneBalancing:           
            if(criteria){
              this.widgetParam.ProductivityInput = criteria.ProductivityInput;
              this.widgetParam.DesiredHourlyUnits = criteria.DesiredHourlyUnits;
              this.getWidgetDetail(this.pageSize, this.pageNumber);               
            }
            break;
      case appSettings.OnTimeShipment:
      case appSettings.TransitionalInventory:  
      case appSettings.MHEMonitoringSummary: 
          dateParam.RangeValue = this._widgetHelper.GetSummaryType(setting.PickType);
          dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(setting.PickType);
          this._analyticsService.getDates(dateParam).subscribe(
            data => {
              if (data.Start_Date.toString() != "0001-01-01T00:00:00" &&
                data.End_Date.toString() != "0001-01-01T23:59:59.999") {
                this.widgetParam.StartDate = new Date(data.Start_Date);
                this.widgetParam.EndDate = new Date(data.End_Date);  
                this.getWidgetDetail(this.pageSize, this.pageNumber);  
              }
            },
            err => {
              console.log("getDates", err);
            }
          );
          break;
      case appSettings.BlindCountError: 
      case appSettings.ForceClosedPackwaves: 
      case appSettings.ToteRecirculating:      
          this.widgetParam.StartDate = moment(new Date(criteria.selectedDate)).add(-timezoneOffset, 'minutes').toDate();
          this.widgetParam.EndDate = moment(new Date(criteria.selectedDate)).add(1, 'day').add(-1, "second").add(-timezoneOffset, 'minutes').toDate();  
          this.getWidgetDetail(this.pageSize, this.pageNumber);  
          break;
      case appSettings.MHENoReadData:        
          dateParam.RangeValue = this._widgetHelper.GetSummaryType(setting.PickType);
          dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(setting.PickType);
          this._analyticsService.getDates(dateParam).subscribe(
            data => {
              if (data.Start_Date.toString() != "0001-01-01T00:00:00" &&
                data.End_Date.toString() != "0001-01-01T23:59:59.999") {
                this.widgetParam.StartDate = new Date(data.Start_Date);
                this.widgetParam.EndDate = new Date(data.End_Date); 
                let startDate = new Date();
                let endDate = new Date();

                if(criteria.SummaryType == null || criteria.SummaryType == 'D') {
                  startDate = moment(new Date(criteria.selectedDate)).toDate();
                  endDate = moment(new Date(criteria.selectedDate)).add(1, 'day').add(-1, "second").toDate();
                }
                else if(criteria.SummaryType == 'W') {
                  startDate = moment(new Date(criteria.selectedDate)).toDate();
                  endDate = moment(new Date(criteria.selectedDate)).add(1, 'week').add(-1, "second").toDate();
                }
                else if(criteria.SummaryType == 'M') {
                  startDate = moment(new Date(criteria.selectedDate)).toDate();
                  endDate = moment(new Date(criteria.selectedDate)).add(1, 'month').add(-1, "second").toDate();
                }
                else if(criteria.SummaryType == 'Q') {
                  let quarterNumber = criteria.selectedDate.substring(4, 5);
                  let yearNumber = criteria.selectedDate.substring(6, 10);
                  startDate = moment(new Date("1/1/" + yearNumber)).add(quarterNumber - 1, 'quarter').toDate();
                  endDate = moment(startDate).add(1, 'quarter').add(-1, "second").toDate();          
                }
                else if(criteria.SummaryType == 'Y') {
                  let yearNumber = criteria.selectedDate;
                  startDate = moment(new Date("1/1/" + yearNumber)).toDate();
                  endDate = moment(startDate).add(1, 'year').add(-1, "second").toDate();          
                }

                if(startDate > this.widgetParam.StartDate) {
                  this.widgetParam.StartDate = moment(startDate).add(-timezoneOffset, 'minutes').toDate();
                }
                else {
                  this.widgetParam.StartDate = moment(this.widgetParam.StartDate).add(-timezoneOffset, 'minutes').toDate();
                }

                if(endDate < this.widgetParam.EndDate) {
                  this.widgetParam.EndDate = moment(endDate).add(-timezoneOffset, 'minutes').toDate();
                }
                else {
                  this.widgetParam.EndDate = moment(this.widgetParam.EndDate).add(-timezoneOffset, 'minutes').toDate();
                }
                this.getWidgetDetail(this.pageSize, this.pageNumber);  
              }
            },
            err => {
              console.log("getDates", err);
            }
          );
          break;
      default:    
          this.getWidgetDetail(this.pageSize, this.pageNumber);     
          break;
    }    
  }

  getWidgetDetail(PageSize, PageNumber, exportData = false) {
    this.loading = true;
    this.ColumnsMatrix = [];
    this.Level2ColumnsMatrix = [];
    let widgetdata: any = this.Widgetdata;

    this.WidgetTitle = widgetdata && widgetdata.Title ? widgetdata.Title : "";
    this.widgetParam.PageNumber = PageNumber;
    this.widgetParam.PageSize = PageSize;

    this._analyticsService.getWidgetDetail(widgetdata.DetailAPI, this.widgetParam).subscribe(data => {
      if (data.KpiDetailList && data.KpiDetailList.length == 0) {
        this.dynamicList = [];
        this.TotalRecordCount = 0;
        this.loading = false;
        return;
      }

      let DisplayColumns = widgetdata.DisplayColumn ? widgetdata.DisplayColumn.split(',') : '';
      let DataColumns = widgetdata.DataColumn ? widgetdata.DataColumn.split(',') : '';
      let DataTypes: Array<string> = widgetdata.DataType ? widgetdata.DataType.split(',') : '';
      
      DataTypes.forEach(function (datatype, index) {
        if (datatype == 'DateTime') {
          data.KpiDetailList.forEach((item) => {
            if (item[DataColumns[index]]) {
              let tDate = moment(item[DataColumns[index]]);
              item[DataColumns[index]] = tDate.format(appSettings.DateTimeFormat);
            }          
          });
        }
      });

      this.ColumnsMatrix = [];
      for (let i in DisplayColumns) {
        let columnNames = {};
        columnNames["DisplayColumn"] = DisplayColumns[i];
        columnNames["DataColumn"] = DataColumns[i].trim();
        this.ColumnsMatrix.push(columnNames);
      }

      if(widgetdata.Level2DataColumn){
        let Level2DisplayColumns = widgetdata.Level2DisplayColumn ? widgetdata.Level2DisplayColumn.split(',') : '';
        let Level2DataColumns = widgetdata.Level2DataColumn ? widgetdata.Level2DataColumn.split(',') : '';
        let Level2DataTypes: Array<string> = widgetdata.Level2DataType ? widgetdata.Level2DataType.split(',') : '';
  
        Level2DataTypes.forEach(function (datatype, index) {
          if (datatype == 'DateTime') {
            data.KpiDetailList.forEach((item) => {        
              if (item[Level2DataColumns[index]]) {
                let tDate = moment(item[Level2DataColumns[index]]);
                item[Level2DataColumns[index]] = tDate.format(appSettings.DateTimeFormat);
              }
            });
          }
        });
  
        this.Level2ColumnsMatrix = [];
        for (let i in Level2DisplayColumns) {
          let level2columnNames = {};
          level2columnNames["DisplayColumn"] = Level2DisplayColumns[i];
          level2columnNames["DataColumn"] = Level2DataColumns[i].trim();
          this.Level2ColumnsMatrix.push(level2columnNames);
        }
      }      

      if (exportData) {
        this._excelGeneratorService.exportData(data.KpiDetailList, this.ColumnsMatrix, (widgetdata.Title) ? widgetdata.Title : "WidgetData");
      }
      else {
        this.dynamicList = data.KpiDetailList;
        this.TotalRecordCount = data.TotalRecordCount;

        switch (widgetdata.type) {
          case appSettings.OpenOrders:
            this.OpenOrdersSummary();
            break;
          case appSettings.HourlyOrders:
            this.HourlyOrdersSummary();
            break;  
        }
      }
      this.loading = false;
    }, error => {
      this.errorMessage = errorMessages.apiError;
      console.log('GetData error:', error);
      this.loading = false;
    });
  }

  toggleExpandRow(row,collapse) {    
    this.detailTable.rowDetail.toggleExpandRow(row);
    if(collapse) return;

    let level2Object = this.dynamicList.find(item => {return item.WAVE == row.WAVE && item.STORE_NUMBER == row.STORE_NUMBER;});
    if(level2Object && (!level2Object.level2Detail || level2Object.level2Detail.length == 0)){
      this.Level2widgetParam.CustomerId = this.widgetParam.CustomerId;
      this.Level2widgetParam.FacilityId = this.widgetParam.FacilityId;
      this.Level2widgetParam.WidgetType = this.Widgetdata.type;

      switch (this.Widgetdata.type) {
        case appSettings.OrdersByStore:
          this.Level2widgetParam.WaveNumber = row.WAVE;
          this.Level2widgetParam.StoreDesc = row.STORE;
          this.Level2widgetParam.PickupTime = row.PICK_UP_TIME;
          break;
       }

      this.loading = true;
      this._analyticsService.getWidgetLevel2Detail(this.Widgetdata.Level2DetailAPI, this.Level2widgetParam).subscribe(data => {    
        this.loading = false;

        if (data.KpiDetailList && data.KpiDetailList.length > 0) { 
            level2Object.level2Detail =  data.KpiDetailList; 
            level2Object.TotalRecordCount = data.TotalRecordCount;
          }       
        },
        error => {
          this.errorMessage = errorMessages.apiError;
          console.log('GetData error:', error);
          this.loading = false;
        });
      }
  }

  facilityChanged(e) {
    this._router.navigateByUrl('/home');
  }

  OpenOrdersSummary(){
    if (this.dynamicList && this.dynamicList.length > 0) {
      let totalOrderNames = {};
      totalOrderNames["DisplayColumn"] = "Total Orders";
      totalOrderNames["DataColumn"] = "Total_Orders";
      this.ColumnsMatrix.push(totalOrderNames);
      let totalQtyNames = {};
      totalQtyNames["DisplayColumn"] = "Total Quantity";
      totalQtyNames["DataColumn"] = "Total_Quantity";
      this.ColumnsMatrix.push(totalQtyNames);
      this.dynamicList.forEach(item => {
        item.REPORT_DATE = item.REPORT_DATE.split(" ")[0];
        let sumTotal_Orders = 0;
        let sumTotal_Quantity = 0;
        for (let i=3;i<(this.ColumnsMatrix.length-2);i++) { //length -2 not to include Total Orders and Total Quantity.
          let col = this.ColumnsMatrix[i];
          if (!item[col.DataColumn]){ //put 0 in the place of null value.
            item[col.DataColumn] = "0";
          }
          if(col.DataColumn.substr(col.DataColumn.trim().length-6).toLowerCase() == "orders"){ //calculating total of each row.
            sumTotal_Orders = sumTotal_Orders + Number(item[col.DataColumn]);
          }
          else{ //Quantity
            sumTotal_Quantity = sumTotal_Quantity + Number(item[col.DataColumn]);
          }
        }
        item.Total_Orders = String(sumTotal_Orders);
        item.Total_Quantity = String(sumTotal_Quantity);
      });
      //calculating total of each column.
      let summaryItem = JSON.parse(JSON.stringify(this.dynamicList[0]));
      summaryItem[this.ColumnsMatrix[0].DataColumn] = ""; //customer id column.
      summaryItem[this.ColumnsMatrix[1].DataColumn] = ""; //facility column.
      summaryItem[this.ColumnsMatrix[2].DataColumn] = "Total:"; //report date column.
      for (let i=3;i<(this.ColumnsMatrix.length);i++) {
        let col = this.ColumnsMatrix[i]; 
        let sumColumn = 0;               
        this.dynamicList.forEach(item => {
          sumColumn = sumColumn + Number(item[col.DataColumn]);
        });
        summaryItem[col.DataColumn] = String(sumColumn);
      }
      this.dynamicList.push(summaryItem);
    }    
  }
  HourlyOrdersSummary(){
    if (this.dynamicList && this.dynamicList.length > 0) {
      //calculating total of each column.
      let summaryItem = JSON.parse(JSON.stringify(this.dynamicList[0]));
      summaryItem[this.ColumnsMatrix[0].DataColumn] = "Total(HR Range)"; //report hour column.
      for (let i=1;i<(this.ColumnsMatrix.length);i++) {
        let col = this.ColumnsMatrix[i]; 
        let sumColumn = 0;               
        this.dynamicList.forEach(item => {
          sumColumn = sumColumn + Number(item[col.DataColumn]);
        });
        summaryItem[col.DataColumn] = String(sumColumn);
      }
      this.dynamicList.push(summaryItem);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/widgetdetails/widgetdetails.component.ts